import { RocheUIStoryType } from '@repo/roche-ui';
import { useTranslation } from './use-translation';

export function useStoryTypeTranslation(storyType: RocheUIStoryType): string | null {
  switch (storyType) {
    case RocheUIStoryType.PODCAST:
      return useTranslation('podcast');
    case RocheUIStoryType.SERIES:
      return useTranslation('series');
    case RocheUIStoryType.SLIDESHOW:
      return useTranslation('slideshow');
    case RocheUIStoryType.VIDEO:
      return useTranslation('video');
    default:
      return null;
  }
}

export function useAllStoryTypeTranslations(): Record<RocheUIStoryType, string> {
  return Object.fromEntries(
    Object.values(RocheUIStoryType)
      .map((type) => {
        const translation = useTranslation(type.toLowerCase());
        return translation !== null ? [type, translation] : null;
      })
      .filter(Boolean) as [RocheUIStoryType, string][],
  ) as Record<RocheUIStoryType, string>;
}
